import React, { useState, useEffect } from 'react';
import BackButton from '../_Shared/BackButton';
import { Form, Col, InputGroup } from "react-bootstrap";
import { useHistory } from "react-router-dom";
import { Formik } from 'formik';
import * as Yup from 'yup';
import { numberValidation, monthValidation} from '../_Shared/Validation';
import result from '../_Shared/Result';
import formulaDefinition from '../_Shared/FormulaDefinition';

function AssetUtilization() {
    const [sale, setSale] = useState(0);
    const [assets, setAssets] = useState(0);
    const [months, setMonths] = useState(0);
    const [total, setTotal] = useState(0);
    const history = useHistory();

    useEffect(() => {

        if (parseInt(months) == ' ') {
            setTotal(
                ((parseInt(sale) / parseInt(assets)))
            );
        }
        else {
            setTotal(
                (((parseInt(sale) / parseInt(months)) * 12) / parseInt(assets))
            );
        }
    }, [sale, months, assets])

    function clickResult() {
        history.push(
            {
                pathname: `/assetutilizationresult?total=${parseFloat(total).toFixed(2)}`
            })
    }

    const validationSchema = Yup.object({
        sale: numberValidation,
        assets: numberValidation,
        months: monthValidation
    });

    const def = <span>Annualized total dealership sales &#247; total assets</span>;

    return (
        <Formik
            initialValues={{ sale: "", assets: "", months: "" }}
            validationSchema={validationSchema}
            onSubmit={e => {
                clickResult();
            }}
        >
            {({ handleSubmit, handleChange, values, errors }) => (

                <div className="container">
                    <main role="main">
                        <div className="jumbotron ">
                            <div className="col-sm-10 mx-auto">
                                <BackButton />
                                <h2 className="text-center">Asset Utilization</h2>

                                {formulaDefinition(def)}

                                <Form onSubmit={handleSubmit}>
                                    <Form.Row>

                                        <Form.Group as={Col} md="12" mb="3" controlId="assets">
                                            <Form.Label>Total Assets</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend><InputGroup.Text>$</InputGroup.Text></InputGroup.Prepend>
                                            <Form.Control size="lg" type="number" name="assets" isInvalid={!!errors.assets}
                                                value={values.assets} onChange={e => { handleChange(e); setAssets(e.target.value) }}
                                            />
                                                <Form.Control.Feedback type="invalid">{errors.assets}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group as={Col} md="12" mb="3" controlId="sale">
                                            <Form.Label>Total Dealership Sales</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend><InputGroup.Text>$</InputGroup.Text></InputGroup.Prepend>
                                            <Form.Control size="lg" type="number" name="sale" isInvalid={!!errors.sale}
                                                value={values.sale} onChange={e => { handleChange(e); setSale(e.target.value) }}  
                                            />
                                                <Form.Control.Feedback type="invalid">{errors.sale}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                        <Form.Group as={Col} md="12" mb="3" controlId="months">
                                            <Form.Label># of Months of Sales $ Entered Above</Form.Label>
                                            <InputGroup className="mb-2"><InputGroup.Prepend><InputGroup.Text>#</InputGroup.Text></InputGroup.Prepend>
                                            <Form.Control size="lg" type="number" name="months" isInvalid={!!errors.months}
                                                value={values.months} onChange={e => { handleChange(e); setMonths(e.target.value) }}
                                            />
                                                <Form.Control.Feedback type="invalid">{errors.months}</Form.Control.Feedback>
                                            </InputGroup>
                                        </Form.Group>

                                    </Form.Row>
                                    <p className="pb-5">
                                        <button className="btn-lg btn-primary btn-block" type="submit">Calculate &raquo;</button>
                                    </p>
                                </Form>
                            </div>
                        </div>
                    </main>
                </div>
            )}
        </Formik>
    );

}

function AssetUtilizationResult() {
    const urlParams = new URLSearchParams(window.location.search);
    const title = "Asset Utilization";
    const total = urlParams.get('total') + " to 1";
    const ratio = "6 to 1";

    const cond = parseFloat(total) >= 6;
    console.log(cond)

    return (
        <div>
            {result(title, total, ratio, cond)}
        </div>
    );
}

export {
    AssetUtilization,
    AssetUtilizationResult
}